import { InfluencerDetailDrawer } from "./components/search/InfluencerDetailDrawer.jsx";
import { Main } from "./Main.jsx";
import { CampaignManagement } from "./pages/campaign/CampaignManagement.jsx";
import { CampaignSearch } from "./pages/campaign/CampaignSearch.jsx";
import { CreateCampaign } from "./pages/campaign/CreateCampaign.jsx";
import { MyCampaign } from "./pages/campaign/MyCampaign.jsx";
import { Search } from "./pages/Search.jsx";
import { Api } from "./utils/apis/indexApi.jsx";
import CustomAxios from "./utils/apis/customAxios.jsx";
import { CampaignForm } from "./components/campaign/CampaignForm.jsx";
import { TrackingNumberForm } from "./components/campaign/TrackingNumberForm.jsx";
import { Chatting } from "./components/Chatting.jsx";
import { Alarm } from "./components/Alarm.jsx";
import { BankAccntForm } from "./components/BankAccntForm.jsx";
import { MyPageForm } from "./components/MyPageForm.jsx";
import { Contract } from "./components/Contract.jsx";
import { ShipmentTracking } from "./pages/ShipmentTracking.jsx";
import { AuthSuccess } from "./pages/AuthSuccess.jsx";
import { InfluencerDashboard } from "./pages/influencer/InfluencerDashboard.jsx";
import { ResetPassword } from "./pages/ResetPassword.jsx";
import { Privacy } from "./docs/Privacy.jsx";
import { Terms } from "./docs/Terms.jsx";
import { Marketing } from "./docs/Marketing.jsx";
import { InfluencerForm } from "./components/InfluencerForm.jsx";
import { BrandForm } from "./components/BrandForm.jsx";
import { LanguageTranslator } from "./components/LanguageTranslator.jsx";
import { InfluencerManagementContent } from "./components/InfluencerManagementContent.jsx";
import { Dashboard } from "./pages/Dashboard.jsx";
import { Membership } from "./pages/Membership.jsx";
import { InviteCampaign } from "./components/InviteCampaign.jsx";
import { BrandCampaignManagement } from "./components/campaign/BrandCampaignManagement.jsx";
import { AgencyCampaignManagement } from "./components/campaign/AgencyCampaignManagement.jsx";
import { Support } from "./pages/Support.jsx";
import { NoticeDetail } from "./pages/NoticeDetail.jsx";
import { PostingCard } from "./components/campaign/PostingCard.jsx";
import { SocialLogin } from "./components/SocialLogin.jsx";
import { SignIn } from "./pages/SignIn.jsx";
import { SignUp } from "./pages/SignUp.jsx";
import { Profile } from "./pages/mypage/Profile.jsx";
import { Setting } from "./pages/mypage/Setting.jsx";
import { InfluencerInvitations } from "./pages/mypage/InfluencerInvitations.jsx";
import { InfluencerProfile } from "./pages/influencer/InfluencerProfile.jsx";
import { CompanyInfo } from "./pages/workspace/CompanyInfo.jsx";
import { MembersManagement } from "./pages/workspace/MembersManagement.jsx";
import { InfluencerManagement } from "./pages/workspace/InfluencerManagement.jsx";
import { CampaignDetailInfo } from "./components/campaign/CampaignDetailInfo.jsx";
import { CampaignCard } from "./components/campaign/CampaignCard.jsx";
import { MyCampaignApplyDetail } from "./components/campaign/MyCampaignApplyDetail.jsx";
import { CampaignShipmentForm } from "./components/campaign/CampaignShipmentForm.jsx";
import { ImageCropper } from "./components/ImageCropper.jsx";
import { Footer } from "./components/Footer.jsx";
import { InfluencerAiAnalysis } from "./components/search/InfluencerAiAnalysis.jsx";
import { FloatChatButton } from "./components/FloatChatButton.jsx";
import { MissionDisplay } from "./components/campaign/MissionDisplay.jsx";
import { PaymentWidget } from "./components/payment/PaymentWidget.jsx";
import { PaymentReturn } from "./pages/payment/PaymentReturn.jsx";
import { InfluencerPaymentHistory } from "./pages/payment/InfluencerPaymentHistory.jsx";
import { BrandPaymentHistory } from "./pages/payment/BrandPaymentHistory.jsx";
import { BrandPaymentHistoryDetail } from "./pages/payment/BrandPaymentHistoryDetail.jsx";
import { Payout } from "./pages/payment/Payout.jsx";
import { CampaignPaymentHistorySection } from "./components/payment/CampaignPaymentHistorySection.jsx";
import { AgencyPaymentHistory } from "./pages/payment/AgencyPaymentHistory.jsx";
import { AgencyPaymentHistoryDetail } from "./pages/payment/AgencyPaymentHistoryDetail.jsx";
import { AudienceInsights } from "./components/search/AudienceInsights.jsx";
import { TiktokTabContent } from "./components/social/TiktokTabContent.jsx";
import { InstagramTabContent } from "./components/social/InstagramTabContent.jsx";
import { YoutubeTabContent } from "./components/social/YoutubeTabContent.jsx";
import { RecentVideosCarousel } from "./components/carousel/RecentVideosCarousel.jsx";
import { InstagramCarousel } from "./components/carousel/InstagramCarousel.jsx";
import { DashboardCarousel } from "./components/carousel/DashboardCarousel.jsx";
import { BrandSocialContents } from "./components/campaign/social-contents/BrandSocialContents.jsx";

export default {
  CustomAxios,
  Api,
  Main,
  Search,

  InfluencerDetailDrawer,

  ShipmentTracking,
  CampaignForm,
  TrackingNumberForm,
  Chatting,
  Alarm,
  BankAccntForm,
  MyPageForm,
  Contract,
  AuthSuccess,
  ResetPassword,
  Privacy,
  Terms,
  Marketing,
  BrandForm,
  InfluencerForm,
  LanguageTranslator,
  InfluencerManagementContent,
  Dashboard,
  Membership,
  InviteCampaign,
  BrandCampaignManagement,
  AgencyCampaignManagement,
  Support,
  NoticeDetail,
  PostingCard,
  SocialLogin,
  SignIn,
  SignUp,
  AudienceInsights,

  // carousel
  DashboardCarousel,
  RecentVideosCarousel,
  InstagramCarousel,

  // social
  TiktokTabContent,
  InstagramTabContent,
  YoutubeTabContent,

  // mypage
  Profile,
  Setting,
  InfluencerInvitations,

  // workspace
  CompanyInfo,
  MembersManagement,
  InfluencerManagement,

  // influencer
  InfluencerProfile,
  InfluencerDashboard,

  // campaign
  CampaignManagement,
  CampaignSearch,
  MyCampaign,
  CreateCampaign,
  CampaignDetailInfo,
  CampaignCard,
  MyCampaignApplyDetail,
  CampaignShipmentForm,
  ImageCropper,
  MissionDisplay,
  BrandSocialContents,

  // payment
  Payout,
  PaymentWidget,
  PaymentReturn,
  InfluencerPaymentHistory,
  BrandPaymentHistory,
  BrandPaymentHistoryDetail,
  CampaignPaymentHistorySection,
  AgencyPaymentHistory,
  AgencyPaymentHistoryDetail,

  Footer,
  InfluencerAiAnalysis,
  FloatChatButton,
};
